import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-delete-alert',
  templateUrl: './store-delete-alert.component.html',
  styleUrls: ['./store-delete-alert.component.scss']
})
export class StoreDeleteAlertComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
